var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.loading)?_c('loading-spinner'):_c('div',[_c('back-button',{attrs:{"fixed":""}}),_c('routine-creator',{attrs:{"hide-use-existing":"","default-routine":_vm.routine}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }